import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Header from '../components/Public/Header';
import Footer from '../components/Public/Footer';
import { SITE } from '../config/site';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found - {SITE.name}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            py: 8,
          }}
        >
          <Container maxWidth="sm">
            <Box sx={{ textAlign: 'center' }}>
              <ErrorOutlineIcon
                sx={{ fontSize: 120, color: 'text.secondary', mb: 2 }}
              />
              <Typography variant="h2" component="h1" gutterBottom>
                404
              </Typography>
              <Typography variant="h5" component="h2" gutterBottom>
                Page Not Found
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                The page you're looking for doesn't exist or has been moved.
              </Typography>
              <Button
                component={RouterLink}
                to="/"
                variant="contained"
                size="large"
                sx={{ mt: 2 }}
              >
                Go Home
              </Button>
            </Box>
          </Container>
        </Box>
        <Footer />
      </Box>
    </>
  );
}
